export const GET_CHANNELS_CONFIGURATION_STATUS = 'GET_CHANNELS_CONFIGURATION_STATUS';
export const GETTING_CHANNELS_CONFIGURATION_STATUS = 'GETTING_CHANNELS_CONFIGURATION_STATUS';
export const SET_CHANNELS_CONFIGURATION_STATUS = 'SET_CHANNELS_CONFIGURATION_STATUS';

export const getChannelsConfigurationStatus = channels => {
  return { type: GET_CHANNELS_CONFIGURATION_STATUS, channels };
};
